export const TOP_ISSUES_SORT_BY = 'sortBy'
export const TOP_ISSUES_GROUP_BY = 'groupBy'
export const FAILURE_STOPPAGE = 'failureStoppage'
export const STOPPAGE_DURATION = 'stoppageDuration'
export const PERFORMANCE_TAB = 'tab'
